export default {
  "content": "<path d=\"M48.167 57.678a4.689 4.689 0 01-3.444-1.35L33.257 45.606a2.425 2.425 0 01-.06-3.488l3.47-3.47a2.424 2.424 0 013.348-.078l8.144 7.425L72.043 22.11a2.424 2.424 0 013.436 0l3.453 3.453a2.424 2.424 0 010 3.436l-27.33 27.329a4.641 4.641 0 01-3.443 1.35h.008z\" fill=\"#DFDFF2\" stroke=\"#484B7D\"/><path d=\"M58.275 54.164v7.694a3.346 3.346 0 01-3.349 3.349H20.639a3.346 3.346 0 01-3.349-3.35V27.563a3.346 3.346 0 013.35-3.349h34.286a3.346 3.346 0 013.349 3.35v4.352l6.914-6.914v-3.22a4.474 4.474 0 00-4.474-4.473H14.86a4.474 4.474 0 00-4.474 4.474v45.856a4.474 4.474 0 004.474 4.474h45.856a4.474 4.474 0 004.474-4.474V47.25l-6.914 6.914z\" fill=\"#DFDFF2\"/>",
  "attrs": {
    "width": "90",
    "height": "90",
    "viewBox": "0 0 90 90",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};